import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "location-selection-wrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, "Fragebogen auswählen", -1)

import AppActivity from "@/components/AppActivity.vue";
import {useRoute, useRouter} from "vue-router";
import {useApiClient} from "@/api";
import {useStore} from "vuex";
import {hideSpinner, showAlert, showAlertSmall, showSpinner} from "@/store";
import {ICON_CANCEL, ICON_FORMULAR_ICON, ICON_OK, ICON_REFRESH} from "@/lib/icons";
import {ref} from "vue";
import QuestionnaireList from "@/components/QuestionnaireList.vue";
import emitter from "@/lib/eventBus";
import UserQuestionnaireEntity from "@/db/UserQuestionnaireEntity";
import getDb from "@/db/Database";
import GetReportResponse from "@/api/responses/GetReportResponse";
import QuestionnaireReleaseEntity from "@/db/QuestionnaireReleaseEntity";
import ReportRequest from "@/api/requests/ReportRequest";
import LocationSelection from "@/components/LocationSelection.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionnaireOverviewActivity',
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const api = useApiClient()

const mode: string = <string>route.params.mode

const configuration = store.state.configuration

const showNoticeAlert = () => {
  showAlertSmall(`<html>
    <body>
        <h1>
            Risikoanalyse:
        </h1>
        <p>
            Die Risikoanalyse ist 1x im Jahr für jede Produktionsart durchzuführen.
        </p>
        <p>
            Das Kapitel Stallklima ist 2x pro Jahr auszufüllen (im Sommer und Winter).
        </p>
        <p>
            Um einen besseren Überblick über die Situation am Betrieb zu bekommen, müssen bei der Beantwortung der Fragen die einzelnen Produktionsstufen (außer Saugferkel) am Anfang und am Ende beurteilt werden.
        </p>
        <p>
            In der Anwendung können zu Beginn die Bereiche Allgemein, Anfang, Ende, Sommer und Winter gewählt werden, um nur die Fragen aus der gewünschten Kategorie zu erhalten.
        </p>
        <p>
            Achtung bei Saugferkeln gibt es die Kategorien Anfang nicht!
        </p>
        <p>
            Die offen gebliebenen Fragen können zu einem späteren Zeitpunkt ausgefüllt werden.
        </p>
        <p>
            Der beantwortete Fragebogen kann abschließend ausgedruckt werden und bei behördlichen Kontrollen vorgelegt werden.
        </p>
    </body>
</html>`)
}

const icons = [
    ICON_FORMULAR_ICON,
    ICON_OK,
    ICON_REFRESH,
    ICON_CANCEL
]

const releaseId = ref<number|null>(null)
const questionnaireId = ref<number|null>(null)
const userQuestionnairePk = ref<number|null>(null)

const refresh = async () => {
  if (await UserQuestionnaireEntity.hasOfflineData(getDb())) {
    store.commit('offline/PROMPT_UPLOAD')
  } else {
    showSpinner()
    api.getReleases(store.state.configuration?.sessionId)
      .then(() => {
        store.commit('SET_LAST_REFRESH', new Date())
        hideSpinner()
        emitter.emit('RELEASES_LOADED')
      })
      .catch((err: any) => {
        hideSpinner()
        showAlert(err.message)
      })
  }
}

const onIconClick = (icon: string) => {
  switch (icon) {
    case ICON_FORMULAR_ICON:
      if (!userQuestionnairePk.value) {
        showAlert('Bitte wählen Sie einen Fragebogen aus!')
        break
      }
      (async () => {
        if (userQuestionnairePk.value) {
          const userQuestionnaire = await UserQuestionnaireEntity.findByPk(getDb(), userQuestionnairePk.value)
          if (userQuestionnaire && userQuestionnaire.id && !userQuestionnaire.dirty) {
            showSpinner()
            const request = new ReportRequest(6, userQuestionnaire.description, userQuestionnaire.id)
            api.createReport(store.state.configuration.sessionId, request)
                .then(async (res: GetReportResponse) => {
                  try {
                    await res.openFile()
                  } catch (error: any) {
                    showAlert('Fehler: ' + error.message)
                  }
                  hideSpinner()
                })
                .catch(err => {
                  console.error('ERROR', err)
                  hideSpinner()
                })
          }
        }
      })()

      break
    case ICON_OK:
      if (!userQuestionnairePk.value) {
        showAlert('Bitte wählen Sie einen Fragebogen aus')
        break
      }
      (async () => {
        if (userQuestionnairePk.value && releaseId.value) {
          const questionnaire = await UserQuestionnaireEntity.findByPk(getDb(), userQuestionnairePk.value)
          const release = await QuestionnaireReleaseEntity.find(getDb(), releaseId.value)
          store.commit('SET_QUESTIONNAIRE', { questionnaire, release })
          switch (mode) {
            case 'check':
              await router.push({ name: 'categoryFilter' });
              break
            case 'analyze':
              await router.push({ name: 'topicOverview' });
              break
            case 'optimize':
              await router.push({ name: 'optimization' });
              break
            default:
              showAlert('not implemented')
          }

        }
      })()
      break
    case ICON_REFRESH:
      refresh()
      break
    case ICON_CANCEL:
      router.push({ name: 'menu' })
      break
  }
}

let needsRefresh = false
if (!store.state.configuration?.lastRefresh) {
  needsRefresh = true
} else {
  const lastRefresh: Date = store.state.configuration.lastRefresh
  const hoursAgo = ((new Date()).getTime() - lastRefresh.getTime()) / 1000 / 60 / 60
  if (hoursAgo >= 24) {
    needsRefresh = true
  }
}

if (needsRefresh) {
  refresh()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    icons: icons,
    onIconClick: onIconClick,
    id: "questionnaire-overview-activity"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(LocationSelection)
      ]),
      _hoisted_2,
      (_unref(mode) === 'check')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "notice",
            onClick: showNoticeAlert
          }, " Hinweise zum Ausfüllen … "))
        : _createCommentVNode("", true),
      _createVNode(QuestionnaireList, {
        mode: _unref(mode),
        "release-id": releaseId.value,
        "questionnaire-id": questionnaireId.value,
        "user-questionnaire-id": userQuestionnairePk.value,
        "onUpdate:releaseId": _cache[0] || (_cache[0] = ($event: any) => ((releaseId).value = $event)),
        "onUpdate:questionnaireId": _cache[1] || (_cache[1] = ($event: any) => ((questionnaireId).value = $event)),
        "onUpdate:userQuestionnaireId": _cache[2] || (_cache[2] = ($event: any) => ((userQuestionnairePk).value = $event))
      }, null, 8, ["mode", "release-id", "questionnaire-id", "user-questionnaire-id"])
    ]),
    _: 1
  }))
}
}

})